import { render, staticRenderFns } from "./RDResult.vue?vue&type=template&id=74886d4e&scoped=true"
import script from "./RDResult.vue?vue&type=script&lang=js"
export * from "./RDResult.vue?vue&type=script&lang=js"
import style0 from "./RDResult.vue?vue&type=style&index=0&id=74886d4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74886d4e",
  null
  
)

export default component.exports